import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit{
  registerForm!: FormGroup;
  errorMessage: string = "";

  constructor(
    private formBuilder: FormBuilder, 
    private userService: UserService,
    private router: Router) {}

  ngOnInit(): void {
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.min(8)]]
    });
  }
  register() {
    if (this.registerForm.valid) {
      this.userService.register({
        name: this.registerForm.value.name,
        email: this.registerForm.value.email,
        password: this.registerForm.value.password
      }).subscribe({
        next: (data) => {
          this.router.navigateByUrl('/');
        },
        error: (error) => {
          console.error(error);
        }
      });
    }
  }
}
